import type { TourCompletionArtifact } from "./types";

/** Mock markdown files opened in the artifact panel when each scenario's
 * demo finishes. Content mirrors the payoff artifact card of its script. */

export const dailyBriefArtifact: TourCompletionArtifact = {
  filename: "daily-brief-jul-2.md",
  markdown: `# Your brief — Thu, Jul 2

Good morning! Here's what needs your attention today.

## 📅 Calendar

| Time | Meeting | Status |
| --- | --- | --- |
| 9:30 AM | Roadmap review | ⚠️ Deck still unshared |
| 1:00 PM | 1:1 with Jordan | Agenda ready |
| 4:30 PM | Hiring sync | 2 candidates to review |

## 📬 Inbox highlights

- **Acme Corp** — 3 unread, contract redlines attached. Legal flagged §4.2.
- **Jordan** — still waiting on your reply about the Q3 pricing proposal.
- **Newsletter digest** — 12 low-priority threads archived automatically.

## ✅ Suggested first moves

1. Share the roadmap deck before the 9:30 review.
2. Reply to Jordan — a draft is waiting in your outbox.
3. Skim the Acme redlines before legal's EOD deadline.

---

_Generated by **Morning Brief** · runs weekdays at 7:00 AM_
`,
};

export const callPrepArtifact: TourCompletionArtifact = {
  filename: "call-prep-acme-corp.md",
  markdown: `# Call prep — Acme Corp · 2:00 PM

## 🏢 Company snapshot

- Series B, ~140 people — raised **$30M in March** (led by Northline Ventures)
- HQ in Austin, TX · B2B logistics software
- Hiring spike in ops and data engineering over the last quarter

## 👤 Who you're meeting

**Dana Patel — VP Operations** (second call)

- Joined Acme 14 months ago from Flexport
- Owns the vendor-consolidation initiative your deal falls under
- Prefers numbers up front, decks later

## 🧵 Open threads

- **Pricing objection** on the per-seat model — Dana asked for a usage-based
  option after the last call.
- Security questionnaire returned, two items pending from your side.

## 💡 Suggested talking points

1. Lead with the usage-based pricing pilot you can now offer.
2. Confirm the security items ship this week.
3. Ask about the Q3 vendor-consolidation timeline — budget closes soon.

---

_Generated by **Call Prep Assistant** · runs 30 min before external calls_
`,
};

export const competitorWatchArtifact: TourCompletionArtifact = {
  filename: "competitor-pricing-report.md",
  markdown: `# Price change detected — Competitor Pro plan

**competitor.com/pricing** · checked today at 8:02 AM

## 📈 What changed

| Plan | Before | After | Change |
| --- | --- | --- | --- |
| Starter | $19/mo | $19/mo | — |
| **Pro** | **$49/mo** | **$59/mo** | **+20.4%** |
| Enterprise | Custom | Custom | — |

## 🔍 Details

- The Pro tier copy now bundles "priority support", previously an add-on.
- Annual billing discount dropped from 20% to 15%.
- No change detected on the Starter or Enterprise tiers.

## 🗒️ Snapshot diff

\`\`\`diff
- Pro — $49/mo, billed annually (save 20%)
+ Pro — $59/mo, billed annually (save 15%), priority support included
\`\`\`

## ✅ Suggested follow-ups

1. Review your own Pro-tier positioning against the new price gap.
2. Sales may want talking points for prospects comparing plans this week.

---

_Generated by **Competitor Pricing Watcher** · runs daily at 8:00 AM_
`,
};

export const supportQueueArtifact: TourCompletionArtifact = {
  filename: "support-queue-triage.md",
  markdown: `# Queue triaged — 14 new tickets

Overnight batch · processed in 40 seconds

## ✍️ Drafted replies (9) — ready for review

- #4821 "Can't export CSV" — known issue, workaround linked
- #4822 "How do I add a teammate?" — steps + invite link drafted
- #4824, #4826–#4831 — password resets and plan questions, standard replies

## 💳 Routed to Sam (3)

- #4823 — refund request, annual plan
- #4825 — invoice shows wrong VAT number
- #4832 — upgrade proration question

## 🚨 Escalated to #support (2)

> **EU outage reports** — two customers in Frankfurt region reporting 502s
> since 5:40 AM. Status page updated, on-call paged.

- #4833 — API timeouts (Frankfurt)
- #4834 — dashboard unreachable (Frankfurt)

## 📊 Queue health

| Metric | Today | 7-day avg |
| --- | --- | --- |
| New tickets | 14 | 17 |
| Auto-drafted | 64% | 58% |
| First-response time | 4 min | 26 min |

---

_Generated by **Support Queue Triage** · runs every morning at 6:00 AM_
`,
};
